/* @ngInject */

export default () => {
  return {
    restrict: 'E',
    scope: {
      data: '='
    },
    link: (scope, element) => {
      if (scope.data && scope.data.data && scope.data.data.length) {
        /*
         * Chart dimensions
         * --------------------------------------------------------------------------------
         */
        const margins = { top: 25, right: 25, bottom: 25, left: scope.data.yAxis ? 75 : 25 };
        const chartWidth = 960;
        const chartHeight = 500;
        const stacks = 1;
        const bars = scope.data.data.length;
        const currency = scope.data.currency;

        /*
         * Chart configuration
         * --------------------------------------------------------------------------------
         */
        const horizontalScale = d3.range(bars);
        const verticalScale = d3
          .range(stacks)
          .map((x) => _.map(scope.data.data, scope.data.dimension));
        const verticalScaleStack = d3.stack().keys(d3.range(stacks))(
          d3.transpose(verticalScale)
        );
        const verticalScaleStackMax = d3.max(verticalScale, (y) => d3.max(y));
        const verticalScaleStackMaxY = d3.max(verticalScaleStack, (y) =>
          d3.max(y, (d) => d[1])
        );

        const svg = d3
          .select(element[0])
          .append('div')
          .attr('class', 'svg-container')
          .append('svg')
          .attr('width', chartWidth)
          .attr('height', chartHeight);
        const width = +svg.attr('width') - margins.left - margins.right;
        const height = +svg.attr('height') - margins.top - margins.bottom;
        const g = svg
          .append('g')
          .attr('transform', `translate(${margins.left}, ${margins.top})`);

        const x = d3.scaleBand().domain(horizontalScale).rangeRound([0, width]).padding(0.08);
        const y = d3.scaleLinear().domain([0, verticalScaleStackMaxY]).range([height, 0]);
        const clBlue = '#5396E5';
        const color = d3.scaleOrdinal().domain(d3.range(stacks)).range([clBlue]);
        const series = g
          .selectAll('.series')
          .data(verticalScaleStack)
          .enter()
          .append('g')
          .attr('fill', (d, i) => color(i));
        const rect = series
          .selectAll('rect')
          .data((d) => d)
          .enter()
          .append('rect')
          .attr('x', (d, i) => x(i))
          .attr('y', height)
          .attr('width', x.bandwidth())
          .attr('height', 0);
        const text = series
          .selectAll('text')
          .data((d) => d)
          .enter()
          .append('text')
          .attr('text-anchor', 'middle')
          .style('fill', '#000')
          .style('font-size', '.65em')
          .attr('x', (d, i) => x(i) + x.bandwidth() / 2)
          .attr('y', (d) => y(d[1]) - 5)
          .text((d) =>
            scope.data.dimension === 'count'
              ? d[1]
              : String(d[1]).formatWithCurrency(currency, 0)
          )
          .style('opacity', 0);

        rect
          .transition()
          .delay((d, i) => i * 100)
          .attr('y', (d) => y(d[1]))
          .attr('height', (d) => y(d[0]) - y(d[1]));
        text
          .transition()
          .delay((d, i) => i * 100)
          .style('opacity', 1);

        /*
         * Chart axises
         * --------------------------------------------------------------------------------
         */
        if (scope.data.xAxis) {
          g.append('g')
            .attr('class', 'axis axis--x')
            .attr('transform', `translate(0, ${height})`)
            .call(
              d3
                .axisBottom(x)
                .tickFormat((d, i) => scope.data.data[i].label)
                .tickSize(0)
                .tickPadding(6)
            );
        }
        if (scope.data.yAxis) {
          g.append('g')
            .attr('class', 'axis axis--y')
            .call(
              d3
                .axisLeft(y)
                .tickFormat((d, i) =>
                  scope.data.dimension === 'count'
                    ? d
                    : String(d).formatWithCurrency(currency, 0)
                )
                .tickSize(0)
                .tickPadding(6)
            );
        }

        /*
         * Chart viewport
         * --------------------------------------------------------------------------------
         */
        svg
          .attr('width', '100%')
          .attr('height', '100%')
          .attr('viewBox', `0 0 ${chartWidth} ${chartHeight}`)
          .attr('preserveAspectRatio', 'xMidYMid meet');
      }
    }
  };
};
